import React from 'react';
import PropTypes from 'prop-types';
import StyledTimeBar, { Meter } from './TimeBar.styled';

const TimeBar = ({ time, started, restarted }) => (
  <StyledTimeBar>
    <Meter
      horz
      time={time}
      started={started}
      className={restarted ? 'restarted' : 'ready'}
    />
    <Meter
      vert
      time={time}
      started={started}
      className={restarted ? 'restarted' : 'ready'}
    />
  </StyledTimeBar>
);

export default TimeBar;

TimeBar.propTypes = {
  time: PropTypes.number.isRequired,
  started: PropTypes.bool.isRequired,
  restarted: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/TimeBar/TimeBar.js